import type {
  LabelWithRole,
  Ownership,
  Review,
} from '@skop-app/lib-domain/types'
import { ReviewType } from '@skop-app/lib-types'

import {
  type CreationSource,
  resolveCreationReviewPolicy,
  type TeamReviewWorkflowPolicyV1,
} from '@/features/reviews'
import type { Metadata } from '@/services/property'
import type { OptionQueryKey } from '@/services/property/property.type'
import {
  buildCreationReviewInput,
  buildMentionTargets,
  buildOptionInput,
} from '@/utils/elementCreation.handler'

export const prepareOptionCreation = (params: {
  elementID: string
  reviewID: string
  inputValue: string
  field: string
  ownership: Ownership
  teammates: LabelWithRole[]
  source: CreationSource
  listOrganizationID?: string
  targetOrganizationID?: string
  isAdmin: boolean
  isSkopAdmin: boolean
  teamReviewWorkflowPolicy: TeamReviewWorkflowPolicyV1 | null | undefined
  parent: { id: string; label: string }
  fieldOptionsId?: string | null
  reviewFieldOptionsId?: string
  optionOptionsId?: string | null
  metadata?: Metadata[]
  value?: string
  group?: string[]
  queryKey: OptionQueryKey
}) => {
  const {
    elementID,
    reviewID,
    inputValue,
    field,
    ownership,
    teammates,
    source,
    listOrganizationID,
    targetOrganizationID,
    isAdmin,
    isSkopAdmin,
    teamReviewWorkflowPolicy,
    parent,
    fieldOptionsId,
    reviewFieldOptionsId,
    optionOptionsId,
    metadata,
    value,
    group,
    queryKey,
  } = params

  const mentions = buildMentionTargets({
    members: teammates,
    ownership,
  })
  const resolution = resolveCreationReviewPolicy({
    elementType: 'option',
    source,
    ownership,
    listOrganizationID,
    isAdmin,
    isSkopAdmin,
    teamReviewWorkflowPolicy,
  })
  const review = resolution.reviewStatus
    ? buildCreationReviewInput({
        reviewID,
        elementID,
        inputValue,
        field,
        reviewType: ReviewType.REVIEW_OPTION,
        ownership,
        reviewStatus: resolution.reviewStatus,
        listOrganizationID,
        targetOrganizationID,
        fieldOptionsId: reviewFieldOptionsId ?? fieldOptionsId ?? parent.id,
        parent,
      })
    : undefined

  const optionInput = buildOptionInput({
    elementID,
    inputValue,
    ownership,
    status: resolution.elementStatus,
    parent,
    targetOrganizationID,
    fieldOptionsId,
    optionOptionsId,
    metadata,
    value,
    group,
    review,
  })

  return {
    optionInput,
    review: review as Review | undefined,
    mentions,
    resolution,
    queryKey,
  }
}
